(ns hypnos.consumer.panels.consult.consent
  "The consult consent step."
  (:require [hypnos.i18n :refer [tr]]
            [hypnos.time :as t]
            [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; helpers

(defn- enable-next?
  [state]
  (not (nil? (get-in @state [:consult :consult/consented-at :value]))))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; fields

(defn- consent-message
  [consult]
  [:article.message.is-info
   [:div.message-body
    [:p (tr :ui.survey.consent/greeting (:consult/service-type consult))]
    [:p (tr :ui.survey.consent/instruction (:consult/service-type consult))]
    [:p (tr :ui.survey.consent/consent)]]])

(defn- consent-field
  [state]
  [:div.field.is-horizontal
   [:div.field-label.is-normal]
   [:div.field-body
    [:div.field
     [:label.switch.is-rounded
      [:input
       {:type      :checkbox
        :value     (not (nil? (get-in @state [:consult :consult/consented-at :value])))
        :on-change (fn [e]
                     (let [old-value (not (nil? (get-in @state [:consult :consult/consented-at :value])))
                           new-value (-> e .-target .-checked)
                           changed?  (or (get-in @state [:consult :consult/consented-at :dirty?])
                                         (not= new-value old-value))]
                       (swap! state assoc-in
                              [:consult :consult/consented-at :value]
                              (when new-value (t/now)))
                       (swap! state assoc-in
                              [:consult :consult/consented-at :dirty?]
                              changed?)))
        :on-focus  (fn [_] (swap! state assoc-in
                                  [:consult :consult/consented-at :touched?]
                                  true))}]
      [:span.check.is-info]
      [:span.control-label (tr :ui.label/agree)]]]]])

(defn- navigation
  [state nav-fn]
  [:div.field.is-grouped
   [:p.control
    [:button.button.is-rounded.is-info
     {:disabled (not (enable-next? state))
      :on-click (fn [_] (nav-fn state :consent :next))}
     (tr :ui.label/next)]]])

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; step

(defn step
  "The consent step"
  [state nav-fn]
  (let [consult (rf/subscribe [:consumer/consult])]
    [:div.card-content
     ;; message and field
     [consent-message @consult]
     [consent-field state]
     [:hr]
     ;; navigation
     [navigation state nav-fn]]))
